import {map, reduce} from 'lodash'
import Flickity from 'flickity-imagesloaded'
import * as modal from './modal'

const jQueryBridget = require('jquery-bridget')
jQueryBridget('flickity', Flickity, $)

const DESKTOP_BREAKPOINT = '58em'

const EVENTS = {
  FLICKITY_CLICK: 'staticClick.flickity',
}

const SELECTORS = {
  BASES: 'html, body',
  SLIDE_WRAP: '.rte .slides',
  SLIDE: '[data-slide-id]',
  SLIDER_PLACEHOLDER: '.archive-article-slider',
  MODAL_PLACEHOLDER: '.archive-article-modal-wrap',
}

const sliderOptions = {
  contain: true,
  cellAlign: 'left',
  imagesLoaded: true,
  pageDots: false,
  percentPosition: false,
  prevNextButtons: false,
  autoPlay: 1500,
  pauseAutoPlayOnHover: false,
}

const $slideWrap = $(SELECTORS.SLIDE_WRAP).eq(0)
const $rawTemplateItems = $slideWrap.find('img, video')
const $sliderPlaceholder = $(SELECTORS.SLIDER_PLACEHOLDER)
const $modalPlaceholder = $(SELECTORS.MODAL_PLACEHOLDER)

const $modalWrap = $(SELECTORS.MODAL_WRAP)

export default () => {
  if (!$rawTemplateItems.length) {
    return
  }

  // convert simplified template (from RTE) into necessary markup
  const slides = parseRawTemplate($rawTemplateItems)
  const sliderTemplate = templatizeSlider(slides)
  const modalTemplate = templatizeModal(slides)

  $sliderPlaceholder.append($(sliderTemplate))
  $modalPlaceholder.append($(modalTemplate))

  // set up slider
  const $slider = $('[data-slider]').flickity(sliderOptions)

  // set up modal
  $(window).on('load', function() {
    modal.init()
  })

  $slider.on(EVENTS.FLICKITY_CLICK, function(event, pointer, cellElement) {
    if (!cellElement) {
      return
    }

    const id = cellElement.getAttribute('data-slide-id')
    modal.open(id)
  })
}

// the "raw" (RTE) template is:
//
// <div class="slides">
//   <img src="..." alt="...">
//   <video src="..." poster="...">
//   <img src="..." alt="...">
//   <!-- etc -->
// </div>
function parseRawTemplate($items) {
  let index = 0

  return map($items, function(item) {
    const $item = $(item)
    index = index + 1

    if ($item.get(0).tagName === 'VIDEO') {
      return {
        type: 'video',
        src: $item.attr('src') || '',
        poster: $item.attr('poster') || '',
        title: $item.attr('title') || '',
        index: index,
      }
    }

    if ($item.get(0).tagName === 'IMG') {
      return {
        type: 'image',
        src: $item.attr('src') || '',
        title: $item.attr('title') || '',
        index: index,
      }
    }
  })
}

function templatizeSlider(items) {
  const compiled = reduce(items, function(a, item) {
    if (item.type === 'image') {
      return a + `<img class="slide__image" data-slide-id="${item.index}" src="${item.src}" alt="${item.title}" title="${item.title}">`
    }

    if (item.type === 'video') {
      return a + `<div class="slide__video" data-slide-id="${item.index}" style="background-image: url(${item.poster})" data-id="${item.src}"></div>`
    }
  }, '')

  return `<div class="slider" data-slider>${compiled}</div>`
}

function templatizeModal(items) {
  const compiled = reduce(items, function(a, item) {
    if (item.type === 'image') {
      return a + `
      <div class="modal modal--dark" data-modal-id="${item.index}" data-media="image">
        <button class="modal__btn-close btn-glitch" data-close-modal-id="${item.index}">Exit</button>
        <div class="modal__inner">
          <div class="modal__content modal__image" style="background-image: url(${item.src})">
            ${item.title}
          </div>
        </div>
      </div>
      `
    }

    if (item.type === 'video') {
      return a + `
      <div class="modal modal--dark" data-modal-id="${item.index}" data-media="video">
        <button class="modal__btn-close btn-glitch" data-close-modal-id="${item.index}">Exit</button>
        <div class="modal__inner">
          <div class="modal__content modal__video" style="background-image: url(${item.poster})">
            <video id="ModalVideo--${item.index}" controls
              class="video-js vjs-foofoo-skin"
              preload="none"
              width="640" height="360"
              poster="${item.poster}"
              data-src="${item.src}"
              data-setup='{
                "sources": [{
                  "src": "${item.src}"
                }]
              }'
            >
            </video>
          </div>
        </div>
      </div>
      `
    }
  }, '')

  return compiled
}



// WEBPACK FOOTER //
// ./archive-detail.js